export default __webpack_public_path__ + "static/media/FIRA.e0d7780c.svg";